import { CertificateInfo } from '@luxtag/papybase';
import FileSaver from 'file-saver';
import { map } from 'lodash';
import Papa from 'papaparse';
import { Component, Vue } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
interface ProductCsv {
    'Seed': string | undefined;
    'Address': string | undefined;
    'Public Key': string | undefined;
    'Private Key': string | undefined;
}

@Component
export default class DownloadCSVMixin extends Vue {
    public downloadCSV(productIds: number[]) {
        const data = map(productIds, (productId) => {
            const product: CertificateInfo = this.$store.getters.getProduct(productId);
            const productCsv: ProductCsv = {
                Seed: product.tag,
                Address: product.address,
                'Public Key': product.public_key,
                'Private Key': product.private_key,
            };
            return productCsv;
        });

        const csv = Papa.unparse(data);

        // write string to file
        const file = new File([csv], 'my_csv.csv', { type: 'text/plain;charset=utf-8' });
        // save file
        FileSaver.saveAs(file);
    }
}
